import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  margin-top: 6px;

  .noactive {
    pointer-events: none;
    opacity: 0.4;
  }

  label {
    font-weight: bold;
  }

  input {
    width: 20px;
    height: 20px;
    margin-right: 6px;
    outline: none;

    ${(props) =>
      props.isFocused &&
      css`
        border-color: #2188ff;
        box-shadow: inset 0 1px 2px rgba(27, 31, 35, 0.075),
          0 0 0 0.2em rgba(3, 102, 214, 0.3);
        transition: all 0.2s ease-in-out;
      `}
    ${(props) =>
      props.isErrored &&
      css`
        border-color: #e02041;
        box-shadow: inset 0 1px 2px rgba(27, 31, 35, 0.075),
          0 0 0 0.2em rgba(224, 32, 65, 0.3);
      `}
    ${(props) =>
      props.isErrored &&
      props.isFilled &&
      css`
        border: 2px solid #d1d5da;
        box-shadow: none;
      `}
  }

  small {
    font-size: 12px;
    font-style: italic;
    color: #e02041;
    margin-top: 4px;
    transition: all 0.2s ease-in-out;
  }
`;
